import React from 'react';
import { LiaChevronDownSolid } from "react-icons/lia";

interface CustomDropdownProps {
    label: string;
    options: string[];
    selectedOption: string;
    setSelectedOption: (option: string) => void;
    }

export default ({...props}: CustomDropdownProps) => {

    const { label, options, selectedOption, setSelectedOption } = props;

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedOption(e.target.value);
    };

    
  return (
    <div className='flex items-center w-full h-10'>
      <select onChange={(e) => handleChange(e)} className={`flex-grow h-full w-11/12 text-center text-xl appearance-none border border-stone-500 shadow-black shadow-md bg-[#1b1a1a] text-[#3da8e2] custom-select rounded-lg ${selectedOption ? 'font-SoulGaze' : 'font-SoulGazeItalic'}`}>
      <option value={selectedOption} disabled selected>{label}</option>
        {options.map((option, index) => (
            <option key={index} value={option} className='w-11/12 md:w-1/3'>{option}</option>
        ))}
      <LiaChevronDownSolid className='bg-[#1b1a1a] text-slate-200 font-bold h-full'/>
      </select>
    </div>
  );
};